import c from 'classnames';
import { wrappingInputRule } from 'prosemirror-inputrules';
import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions } from '@lyearn/lygo-core';

import { NODE_NAME, ORDERED_LIST_REGEX } from './consts';
import plugins from './plugins';
import { orderedListStyles } from './styles';

export default class OrderedList extends BaseExtension {
  protected _schema: NodeSpec = {
    content: 'list_item+',
    group: 'block',
    attrs: { order: { default: 1 } },
    parseDOM: [
      {
        tag: 'ol',
        getAttrs: (dom) => ({
          order: (dom as HTMLElement).hasAttribute('start')
            ? (dom as HTMLElement).getAttribute('start')
            : 1,
        }),
      },
    ],
    toDOM: (node) => [
      'ol',
      {
        class: c('list-decimal mt-8 ps-4', orderedListStyles),
        start: node.attrs.order == 1 ? null : node.attrs.order,
      },
      0,
    ],
  };

  get schema(): NodeSpec {
    return this._schema;
  }

  get name(): string {
    return NODE_NAME;
  }

  inputRules = ({ schema }: EditorOptions) => {
    //ref: https://github.com/ProseMirror/prosemirror-example-setup/blob/6bd92b0712bf389cfe7ec26904230f959643e60b/src/inputrules.js#L14
    return [
      wrappingInputRule(
        ORDERED_LIST_REGEX,
        schema.nodes.ordered_list,
        (match) => {
          if (match[1]) {
            return { order: +match[1] };
          }
        },
        (match, node) => {
          if (match[1]) {
            return node.childCount + node.attrs.order == +match[1];
          }
          return false;
        },
      ),
    ];
  };

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
      getAttrs: (tok) => ({
        order: parseInt(tok.attrGet('start') ?? '1', 10),
      }),
    };
  }

  plugins = plugins;
}
